export default __webpack_public_path__ + "static/media/CircularStdBold.281f705c.woff2";